import { render, staticRenderFns } from "./InactivityModal.vue?vue&type=template&id=4aa15a2e&scoped=true"
import script from "./InactivityModal.vue?vue&type=script&lang=js"
export * from "./InactivityModal.vue?vue&type=script&lang=js"
import style0 from "./InactivityModal.vue?vue&type=style&index=0&id=4aa15a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa15a2e",
  null
  
)

export default component.exports